import { useCallback, useMemo, useState } from 'react';

export const useModalState: (
  defaultState?: boolean,
) => {
  isOpen: boolean;
  close: () => void | undefined;
  open: () => void | undefined;
} = (defaultState = false) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultState);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  return useMemo(() => ({ isOpen, close, open }), [isOpen, close, open]);
};
